import { rebind } from "../utils";
import rangeBarsCalculator from "../calculator/rangeBars";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "RangeBars";

export default function () {
  const base = baseIndicator().type(ALGORITHM_TYPE);
  const underlyingAlgorithm = rangeBarsCalculator();

  const indicator = underlyingAlgorithm;

  rebind(indicator, base, "id", "stroke", "fill", "echo", "type");
  rebind(
    indicator,
    underlyingAlgorithm,
    "dateAccessor",
    "dateMutator",
    "options",
  );

  return indicator;
}
